import { render, staticRenderFns } from "./horizontalLinkBoxes.vue?vue&type=template&id=b7b4f68a&scoped=true&"
import script from "./horizontalLinkBoxes.vue?vue&type=script&lang=js&"
export * from "./horizontalLinkBoxes.vue?vue&type=script&lang=js&"
import style0 from "./horizontalLinkBoxes.vue?vue&type=style&index=0&id=b7b4f68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b4f68a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7b4f68a')) {
      api.createRecord('b7b4f68a', component.options)
    } else {
      api.reload('b7b4f68a', component.options)
    }
    module.hot.accept("./horizontalLinkBoxes.vue?vue&type=template&id=b7b4f68a&scoped=true&", function () {
      api.rerender('b7b4f68a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/horizontalLinkBoxes.vue"
export default component.exports